module.exports = __webpack_public_path__ + "static/media/jm.4370e527.svg";